import React from 'react';
import { connect } from 'react-redux';
import { memo } from 'common/hocs/memo';
import { mapDispatchToProps, mapStateToProps } from './product-maps';
import { ProductLogicProps } from './product.types';
import { useProductLogic } from './use-product-logic';
import { ProductCard } from 'common/components';

export const ProductLogic = memo<ProductLogicProps>(function ProductLogic({
  className,
  type = 'large-card',
  elementBlock = 'not set',
  product,
  subtitle,
  inBasket,
  isBasketLoading,
  qty = 0,
  productPosition,
  addToBasket,
  removeFromBasket,
  loadBasket,
  updateBasket,
  reviews,
  updateCartItem,
  inWidget,
  inShoplist,
  addToShoplist,
  removeFromShoplist,
  analytics,
}) {
  const {
    productRef,
    review,
    label,
    handleAddToCart,
    handleUpdateCart,
    handleRemoveFromCart,
    onClick,
    toggleShoplist,
  } = useProductLogic({
    elementBlock,
    product,
    qty,
    productPosition,
    addToBasket,
    removeFromBasket,
    loadBasket,
    updateBasket,
    reviews,
    updateCartItem,
    analytics,
    inShoplist,
    addToShoplist,
    removeFromShoplist,
  });

  return (
    <ProductCard
      className={className}
      product={product}
      subtitle={subtitle}
      productPosition={productPosition}
      ref={productRef}
      type={type}
      label={label}
      inBasket={inBasket}
      isBasketLoading={isBasketLoading}
      qty={qty}
      onClick={onClick}
      onCartAdd={handleAddToCart}
      onQtyUpdate={handleUpdateCart}
      onCartRemove={handleRemoveFromCart}
      onShoplistToggle={toggleShoplist}
      reviews={review}
      inWidget={inWidget}
      inShoplist={inShoplist}
      elementBlock={elementBlock}
    />
  );
});

export const Product = connect(mapStateToProps, mapDispatchToProps)(ProductLogic);
